/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuditEventGroup,
  AuditEventType,
  AuditQueryRequest,
  AuditTagValue,
  ChiliProduct,
  MapString,
  PaginatedResultA,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "audit";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description returns all audit logs with matching tags
   *
   * @tags Queries
   * @name QueryAuditLogs
   * @request GET:/v1/tenant/{tenantId}/audit-logs
   * @secure
   */
  queryAuditLogs = (
    tenantId: string,
    query: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * @format date-time
       * @example "2025-07-08T15:51:03.180303273Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-09T15:51:03.180367523Z"
       */
      until?: string;
      tenantId?: string[];
      workspaceId?: string[];
      teamIdOld?: string[];
      teamId?: string[];
      userId?: string[];
      auditEventGroup?: AuditEventGroup[];
      auditEventType?: AuditEventType[];
      ruleId?: string[];
      distributionId?: string[];
      caller?: string[];
      chiliProduct?: ChiliProduct[];
      nextInLine?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultA,
      | AuditTagValue
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryAuditLogs */
  queryAuditLogsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * @format date-time
       * @example "2025-07-08T15:51:03.180303273Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-09T15:51:03.180367523Z"
       */
      until?: string;
      tenantId?: string[];
      workspaceId?: string[];
      teamIdOld?: string[];
      teamId?: string[];
      userId?: string[];
      auditEventGroup?: AuditEventGroup[];
      auditEventType?: AuditEventType[];
      ruleId?: string[];
      distributionId?: string[];
      caller?: string[];
      chiliProduct?: ChiliProduct[];
      nextInLine?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/audit-logs`, query);

  /**
   * @description returns all audit logs with matching tags
   *
   * @tags Queries
   * @name MultiQueryAuditLogs
   * @request POST:/v1/tenant/{tenantId}/multi-query-audit-logs
   * @secure
   */
  multiQueryAuditLogs = (
    tenantId: string,
    query: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * @format date-time
       * @example "2025-07-08T15:51:03.180303273Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-09T15:51:03.180367523Z"
       */
      until?: string;
    },
    data: AuditQueryRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultA,
      | AuditTagValue
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/multi-query-audit-logs`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for multiQueryAuditLogs */
  multiQueryAuditLogsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * @format date-time
       * @example "2025-07-08T15:51:03.180303273Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-09T15:51:03.180367523Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/multi-query-audit-logs`, query);
}
